import WalletSVG from "../../../../Assets/svg/wallet.svg";
import DynaInputKeyword from "../../DynaInput/DynaInputKeyword";
import Options from "../../../Option/Options";
import './WalletCharge.scss'
import {useState} from "react";
import axios from "axios";
import {prefixUrl} from "../../../../Utils/utilsData";
import {toast} from "react-toastify";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../../../Utils/CommaSeparator";

const WalletCharge = () => {

  const [amount, setAmount] = useState(0)

  const chargeGatewayHandler = (the_amount) => {
    axios.get(`${prefixUrl()}/user/chargeWallet.php?price=${the_amount}`)
      .then((response) => window.location.replace(response.data.message))
      .catch((error) => {
        toast.error("خطا در بر قراری ارتباط")
        console.error("Error sending GET request:", error)
      })
  }

  const chargeOptionHandler = (value) => () => {
    // optional to store the clicked value
    setAmount(value)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && amount) {
      chargeGatewayHandler(amount)
    }
  };

  const handleInputChange = (e) => {
    setAmount(Number(parseToEnRemoveComma(e.target.value)))
  }

  return (
    <section className="WalletChargeContainer">
      <section className="WalletCharge">
        <img src={WalletSVG} alt="WalletSVG"/>
        <h3>مبلغ شارژ مورد نظر خود را وارد نمایید</h3>
        {/* this input has a keyword and this feature is not seen in the DynaInput and don't wanna change the structure in there so gotta write a new component */}
        <DynaInputKeyword
          name="chargeamount"
          id="chargeamount"
          label="مبلغ شارژ دلخواه"
          type="text"
          placeholder="مبلغ موردنظر وارد کنید"
          className={`solid-login-Personal-Information`}
          keyword='ریال'
          value={formatToPersianAddComma(amount)}
          onKeyUp={handleKeyPress}
          onChange={handleInputChange}
        />
        <Options
          className='centric col5grid'
          onClick={chargeOptionHandler}
          items={[
            {
              value: 500000,
              active: true
            }, {
              value: 1000000,
            }, {
              value: 2000000,
            }, {
              value: 5000000,
            }, {
              value: 10000000,
            }, {
              value: 20000000,
            }, {
              value: 30000000,
            }, {
              value: 40000000,
            }
          ]}/>
        <button className={"pay-but"} onClick={() => chargeGatewayHandler(amount)}>پرداخت</button>
      </section>
    </section>
  )
}
export default WalletCharge;
